module.exports = __webpack_public_path__ + "img/Allure_logo.91dabdc5.svg";